export const toolCards = [
  {
    id: 'loi-lo',
    icon: 'ri-line-chart-line',
    title: 'Công cụ Forex Lãi/Lỗ',
    desc: 'Dự phóng lợi nhuận.',
    accent: '#7C3AED',
    to: '/lai-lo',
  },
  {
    id: 'sut-giam',
    icon: 'ri-arrow-down-circle-line',
    title: 'Máy tính Forex Sụt giảm',
    desc: 'Đo lường rủi ro phá sản.',
    accent: '#818CF8',
    to: '/rui-ro',
  },
  {
    id: 'pivot',
    icon: 'ri-focus-3-line',
    title: 'Công cụ Forex Pivot',
    desc: 'Vẽ mức cản tự động.',
    accent: '#7C3AED',
    to: '/ky-thuat',
  },
  {
    id: 'ky-quy',
    icon: 'ri-scales-3-line',
    title: 'Máy tính Forex Ký quỹ',
    desc: 'Kiểm soát đòn bẩy.',
    accent: '#818CF8',
    to: '/may-tinh-ky-quy',
  },
];

export const brokers = [
  {
    name: 'IC Markets',
    spread: 0.0,
    swapLong: -0.18,
    swapShort: 0.05,
    commission: 7,
    tag: 'Raw',
    cheapest: true,
  },
  {
    name: 'FxPro',
    spread: 0.1,
    swapLong: -0.22,
    swapShort: 0.08,
    commission: 0,
    tag: 'Raw Spread',
    cheapest: false,
  },
  {
    name: 'XM',
    spread: 0.7,
    swapLong: -0.35,
    swapShort: 0.15,
    commission: 0,
    tag: 'Standard',
    cheapest: false,
  },
];

export const dockTools = [
  { id: 'position', icon: 'ri-crosshair-line', label: 'Position', to: '/may-tinh-khoi-luong' },
  { id: 'margin', icon: 'ri-bank-line', label: 'Margin', to: '/may-tinh-ky-quy' },
  { id: 'profit', icon: 'ri-line-chart-line', label: 'Profit', to: '/lai-lo' },
  { id: 'pivot', icon: 'ri-focus-3-line', label: 'Pivot', to: '/ky-thuat' },
];

export const tickerQuotes = [
  { symbol: 'EUR/USD', price: 1.0842, decimals: 4, delta: 0.0012 },
  { symbol: 'GBP/USD', price: 1.2715, decimals: 4, delta: -0.0008 },
  { symbol: 'AUD/USD', price: 0.6587, decimals: 4, delta: 0.0003 },
  { symbol: 'USD/JPY', price: 151.24, decimals: 2, delta: -0.42 },
  { symbol: 'USD/CAD', price: 1.3591, decimals: 4, delta: 0.0009 },
  { symbol: 'XAU/USD', price: 2392.4, decimals: 1, delta: 8.6 },
];